type TupleToMirrorObject<T extends readonly string[]> = {
    [K in T[number]]: K;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const enumeration = <T extends readonly string[]>(values: [...T]) => {
    const obj = {} as TupleToMirrorObject<T>;

    for (const element of values) {
        obj[element] = element;
    }

    return obj;
};

type TEnumerationValue<T extends Record<string, string>> = T[keyof T];

export {enumeration as default, type TEnumerationValue};
